import {ACCESS_EXPIRE_TIME, LAST_ACTIVITY_KEY, REFRESH_EXPIRE_TIME} from "../constants";
import {removeCookie, setCookie} from "./cookie";
import {startActivityMonitor} from "./activityMonitor";

export const setAuth = ({accessToken, refreshToken}: {accessToken: string; refreshToken: string}) => {
	const accessExpire = new Date();
	accessExpire.setMinutes(accessExpire.getMinutes() + ACCESS_EXPIRE_TIME);

	setCookie("ACCESS_TOKEN", accessToken, {
		expires: accessExpire,
		path: "/",
		secure: import.meta.env.PROD,
		sameSite: import.meta.env.PROD ? "strict" : "lax"
	});

	const refreshExpire = new Date();
	refreshExpire.setMinutes(refreshExpire.getMinutes() + REFRESH_EXPIRE_TIME);

	setCookie("REFRESH_TOKEN", refreshToken, {
		expires: refreshExpire,
		path: "/",
		secure: import.meta.env.PROD,
		sameSite: import.meta.env.PROD ? "strict" : "lax"
	});

	startActivityMonitor();
};

export const setAccessToken = ({accessToken}: {accessToken: string}) => {
	const accessExpire = new Date();
	accessExpire.setMinutes(accessExpire.getMinutes() + ACCESS_EXPIRE_TIME);

	setCookie("ACCESS_TOKEN", accessToken, {
		expires: accessExpire,
		path: "/",
		secure: import.meta.env.PROD,
		sameSite: import.meta.env.PROD ? "strict" : "lax"
	});
};

export const resetAuth = () => {
	removeCookie("ACCESS_TOKEN", {path: "/"});
	removeCookie("REFRESH_TOKEN", {path: "/"});
	localStorage.removeItem(LAST_ACTIVITY_KEY);
};